import React, { useState } from 'react'
import { Button, Col, Form, Input, message, Row, Select, Switch, Upload } from 'antd'
import Avatar from '../Avatar'
import { HeroType, provinces } from '../../../../config'
import { compressFile } from '../../../../utils/services'
import { useDispatch } from 'react-redux'
import { saveHeroImage, updateHeroProfile } from '../../../../modules/hero'
import { inputRule, selectRule } from '../../../../utils/rules'
import { isEmpty } from 'lodash'
import { useDeepEffect } from '../../../../utils/hooks'
import axios from 'axios'

function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }
  return false
}

export const HeroForm = ({
  data,
  heroDetail,
  statusOptions,
  heroTypeOptions,
  form,
  onOk
}) => {
  const dispatch = useDispatch()
  const { getFieldDecorator, validateFields, setFieldsValue, isFieldTouched } =
    form
  const [imageUrl, setImageUrl] = useState('')
  const wasteBankLoaded =
    !isEmpty(heroDetail) && !isEmpty(data) && heroDetail.id === data.id

  useDeepEffect(() => {
    if (!isEmpty(data)) {
      setFieldsValue({
        tel: data.tel,
        email: data.email,
        password: data.password,
        heroType: data.heroType,
        name: data.name,
        firstname: data.firstName,
        lastname: data.lastName,
        address: data.address,
        subDistrict: data.subDistrict,
        district: data.district,
        province: data.province,
        zipcode: data.zipcode,
        lineId: data.lineId,
        plateLicense: data.plateLicense,
        purpose: data.purpose,
        postalAddress: data.postalAddress,
        status: data.status
      })
    }

    return () => {
      form.resetFields()
    }
  }, [data])

  useDeepEffect(() => {
    if (wasteBankLoaded) {
      setFieldsValue({
        isWasteBank: heroDetail.isWasteBank === true
      })
    }
  }, [heroDetail, data])

  const handleUploadChange = async (info) => {
    getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
    const formData = new FormData()
    formData.append('heroId', data.id)
    formData.append('image', await compressFile(info.file))
    await dispatch(saveHeroImage(formData))
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const formData = {
          id: data.id || 0,
          address: values.address,
          district: values.district,
          email: values.email,
          firstName: values.firstname,
          heroName: values.name,
          heroType: values.heroType,
          lastName: values.lastname,
          lineId: values.lineId,
          password: values.password,
          province: values.province,
          status: values.status,
          subDistrict: values.subDistrict,
          tel: values.tel,
          zipcode: values.zipcode,
          plateLicense: values.plateLicense,
          postalAddress: values.postalAddress,
          purpose: values.purpose,
          // ส่งเฉพาะเมื่อรู้ค่าจริง (โหลดรายละเอียด hero แล้ว) หรือแอดมินกดสวิตช์เอง
          // ไม่งั้นสวิตช์ว่างจะส่ง false ไปปิดธนาคารขยะของร้าน — backend: ไม่ส่ง = ไม่เปลี่ยน
          ...(wasteBankLoaded || isFieldTouched('isWasteBank')
            ? { isWasteBank: values.isWasteBank === true }
            : {})
        }
        try {
          if (!isEmpty(data)) {
            if (values.tel != data.tel) {
              const res = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/hero/existingTel`,
                {
                  tel: values.tel
                }
              )
              if (!res.data.isExist) {
                await dispatch(updateHeroProfile(formData))
                await onOk()
              } else {
                message.error(res.data.message)
              }

            } else if (values.email != data.email) {
              const res = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/hero/existingEmail`,
                {
                  email: values.email
                }
              )
              if (!res.data.isExist) {
                await dispatch(updateHeroProfile(formData))
                await onOk()
              } else {
                message.error(res.data.message)
              }
            } else {
              await dispatch(updateHeroProfile(formData))
              await onOk()
            }
          } else {
            const res = await axios.post(
              `${process.env.REACT_APP_API_ENDPOINT}/hero/existing`,
              {
                email: values.email,
                name: values.name,
                tel: values.tel
              }
            )

            if (!res.data.isExist) {
              await dispatch(updateHeroProfile(formData))
              await onOk()
            } else {
              message.error(res.data.message)
            }
          }
        } catch (err) {
          console.log(err)
        }
      }
    })
  }

  return (
    <Form onSubmit={onSubmit}>
      {!isEmpty(data) && (
        <Row type="flex" justify="center">
          <Col>
            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              beforeUpload={beforeUpload}
              onChange={handleUploadChange}>
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="avatar"
                  style={{ width: 128, height: 128 }}
                />
              ) : (
                <Avatar src={data.imageUrl} size={128} />
              )}
            </Upload>
          </Col>
        </Row>
      )}
      <Form.Item label="เบอร์โทรศัพท์ (Mobile Phone Number)">
        {getFieldDecorator(`tel`, { ...inputRule })(
          <Input placeholder="08xxxxxxxx" type="text" />
        )}
      </Form.Item>
      <Form.Item label="อีเมล (Email)">
        {getFieldDecorator(`email`, {
          rules: [
            { required: true, message: 'กรุณากรอก' },
            {
              type: 'email',
              message: 'กรอกรูปแบบอีเมล'
            }
          ]
        })(
          <Input
            name="email"
            placeholder="email"
          // disabled={Boolean(data.hero)}
          />
        )}
      </Form.Item>
      <Form.Item label="รหัสผ่าน (Password)">
        {getFieldDecorator(`password`, {
          rules: [
            { required: isEmpty(data), message: 'กรุณากรอก' },
            {
              min: 6,
              message: 'กรอกอย่างน้อย 6 ตัวอักษร'
            }
          ]
        })(
          <Input.Password
            placeholder="อย่างน้อย 6 ตัวอักษร"
            type="password"
            autoComplete="off"
            // disabled={!isEmpty(data)}
          />
        )}
      </Form.Item>
      <Form.Item label="ประเภทของฮีโร่ (Type of Hero)">
        {getFieldDecorator(`heroType`, { ...selectRule })(
          <Select placeholder="เลือกประเภทของฮีโร่">
            {heroTypeOptions.map((item) => {
              return (
                <Select.Option key={item}>{HeroType[item].title}</Select.Option>
              )
            })}
          </Select>
        )}
      </Form.Item>
      <Form.Item label="ชื่อฮีโร่ (Hero Name)">
        {getFieldDecorator(`name`, { ...inputRule })(
          <Input placeholder="ชื่อร้าน / โครงการ / ทีม" type="text" />
        )}
      </Form.Item>

      <Form.Item label="ชื่อผู้รับผิดชอบ (Firstname)">
        {getFieldDecorator(`firstname`)(
          <Input placeholder="ชื่อ" type="text" />
        )}
      </Form.Item>
      <Form.Item label="นามสกุลผู้รับผิดชอบ (Lastname)">
        {getFieldDecorator(`lastname`)(
          <Input placeholder="นามสกุล" type="text" />
        )}
      </Form.Item>
      <Form.Item label="ที่อยู่ (Address)">
        {getFieldDecorator(`address`)(<Input type="text" />)}
      </Form.Item>
      <Form.Item label="ตำบล (Sub District)">
        {getFieldDecorator(`subDistrict`)(<Input type="text" />)}
      </Form.Item>
      <Form.Item label="อำเภอ (District)">
        {getFieldDecorator(`district`)(<Input type="text" />)}
      </Form.Item>
      <Form.Item label="จังหวัด (Province)">
        {getFieldDecorator(`province`)(
          <Select showSearch placeholder="เลือกจังหวัด" name="province">
            {provinces.map((option, index) => (
              <Select.Option
                key={`province-${index.toString()}`}
                value={option.name_th}>
                {option.name_th}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <Form.Item label="รหัสไปรษณีย์ (Zip Code)">
        {getFieldDecorator(`zipcode`)(<Input type="text" />)}
      </Form.Item>
      <Form.Item label="ไอดีไลน์ (LINE ID)">
        {getFieldDecorator(`lineId`)(
          <Input type="text" placeholder="LINE ID" />
        )}
      </Form.Item>
      {data && data.heroType === 'SCOOTER' && (
        <Form.Item label="ทะเบียนรถ (Car License Number)">
          {getFieldDecorator(`plateLicense`, { ...inputRule })(
            <Input type="text" placeholder="1กก 9999 กรุงเทพมหานคร" />
          )}
        </Form.Item>
      )}

      {data &&
        (data.heroType === 'DROP_POINT' || data.heroType === 'POSTAL') && (
          <Form.Item label="จุดประสงค์การรับบริจาค (The purpose of receiving donations)">
            {getFieldDecorator(`purpose`, { ...inputRule })(
              <Input.TextArea
                autosize={{ minRows: 3, maxRows: 6 }}
                type="text"
              />
            )}
          </Form.Item>
        )}
      {data && data.heroType === 'POSTAL' && (
        <Form.Item label="ที่อยู่จัดส่ง (Delivery Address)">
          {getFieldDecorator(`postalAddress`, { ...inputRule })(
            <Input.TextArea type="text" autosize={{ minRows: 3, maxRows: 6 }} />
          )}
        </Form.Item>
      )}
      <Form.Item label="Status">
        {getFieldDecorator(`status`, { ...selectRule })(
          <Select placeholder="Select Status">
            {statusOptions &&
              statusOptions.map((status) => (
                <Select.Option key={status}>{status}</Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
      <Form.Item label="ธนาคารขยะ (Waste Bank)">
        {getFieldDecorator(`isWasteBank`, { valuePropName: 'checked' })(
          <Switch checkedChildren="เปิด" unCheckedChildren="ปิด" />
        )}
      </Form.Item>
      <Row type="flex" justify="end">
        <Button type="primary" htmlType="submit">
          บันทึก
        </Button>
      </Row>
    </Form>
  )
}

const WrappedHeroForm = Form.create({
  name: 'HeroForm'
})(HeroForm)
export default WrappedHeroForm
